import { useAuth } from 'react-oidc-context';
import { trackEvent } from '../../tracking/tracking';

const useDestroyUserSession = (): { logoutUser: () => void } => {
  const auth = useAuth();

  const logoutUser = (): void => {
    try {
      trackEvent({ event: 'logout' });
    } catch (trackingError) {
      console.error('Logout tracking failed:', trackingError);
    }

    window.dispatchEvent(new CustomEvent('EndUser3rdPartyLogout'));
    window.localStorage.removeItem('one-time-token');
    auth.signoutRedirect({
      redirectMethod: 'replace',
      id_token_hint: auth.user?.id_token,
    });
  };

  return { logoutUser };
};

export default useDestroyUserSession;
